import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IAidasOrganisation } from 'app/shared/model/ainnotateservice/aidas-organisation.model';
import { getEntities as getAidasOrganisations } from 'app/entities/ainnotateservice/aidas-organisation/aidas-organisation.reducer';
import { getEntity, updateEntity, createEntity, reset } from './aidas-customer.reducer';
import { IAidasCustomer } from 'app/shared/model/ainnotateservice/aidas-customer.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasCustomerUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const aidasOrganisations = useAppSelector(state => state.aidasOrganisation.entities);
  const aidasCustomerEntity = useAppSelector(state => state.aidasCustomer.entity);
  const loading = useAppSelector(state => state.aidasCustomer.loading);
  const updating = useAppSelector(state => state.aidasCustomer.updating);
  const updateSuccess = useAppSelector(state => state.aidasCustomer.updateSuccess);

  const handleClose = () => {
    props.history.push('/aidas-customer' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getAidasOrganisations({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...aidasCustomerEntity,
      ...values,
      aidasOrganisation: aidasOrganisations.find(it => it.id.toString() === values.aidasOrganisationId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...aidasCustomerEntity,
          aidasOrganisationId: aidasCustomerEntity?.aidasOrganisation?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="ainnotategwApp.ainnotateserviceAidasCustomer.home.createOrEditLabel" data-cy="AidasCustomerCreateUpdateHeading">
            Create or edit a AidasCustomer
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="aidas-customer-id" label="ID" validate={{ required: true }} />
              ) : null}
              <ValidatedField
                label="Name"
                id="aidas-customer-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                  minLength: { value: 3, message: 'This field is required to be at least 3 characters.' },
                  maxLength: { value: 500, message: 'This field cannot be longer than 500 characters.' },
                }}
              />
              <ValidatedField label="Description" id="aidas-customer-description" name="description" data-cy="description" type="text" />
              <ValidatedField
                id="aidas-customer-aidasOrganisation"
                name="aidasOrganisationId"
                data-cy="aidasOrganisation"
                label="Aidas Organisation"
                type="select"
                required
              >
                {aidasOrganisations
                  ? aidasOrganisations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>This field is required.</FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/aidas-customer" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AidasCustomerUpdate;
